import { APP_NAME } from "../constant/constant";
import logoTara from "../assets/logo_tara.png";

const NavImage = () => {
  return (
    <>
    <img src={logoTara} alt={`${APP_NAME} logo`} className="nvg_logo" />
    </>
  );
};

export default NavImage;
